<template>
  <div>
    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list id="68170894" dense>
        <v-list-item v-for="item in hasMatchedItemRolesAndFeatures" :id="item.id" :key="item.title" :to="item.link">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="blue darken-3" dark clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>Trident {{ setAllowedFeaturesToToolbarTitle(getAllowedFeatureList) }} - WebAdmin</v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-if="isLoggedIn">
        <v-menu offset-y>
          <template v-slot:activator="{ on: menu }">
            <div class="hand" v-on="{ ...menu }">
              <v-avatar
                color="indigo"
                class="mr-2"
              >
                <v-icon dark>mdi-account</v-icon>
              </v-avatar>
              {{ username }}
            </div>
          </template>
          <v-list>
            <v-list-item @click="changePassword">
              <v-list-item-title> {{ $t('changePassword') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn id="7570aa76" icon @click="logout">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </template>
    </v-app-bar>

    <v-content>
      <v-container class="fill-height" fluid>
        <!-- <keep-alive> -->
        <router-view></router-view>
        <!-- </keep-alive> -->
      </v-container>
    </v-content>

    <!-- TODO 'app' prop nem kell ha drawerben nem akarod a footert -->
    <!-- <v-footer color="indigo" app>
      <v-spacer></v-spacer>
      <span class="white--text">&copy; {{ new Date().getFullYear() }} i4p. {{ $t('allRightsReserved') }}</span>
    </v-footer> -->

    <!-- changePasswordDialog -->
    <v-row justify="center">
      <v-dialog v-model="changePasswordDialogShowed" persistent max-width="450">
        <v-form ref="form" v-model="valid">
          <v-card>
            <v-card-title>
              <span class="headline">{{ $t('changePassword') }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="oldPassword"
                      :label="$t('password')"
                      :rules="[rules.required]"
                      type="password"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="newPassword"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      :label="this.$t('newPassword')+`*`"
                      :counter="maxCharacters"
                      :type="showPassword ? 'text' : 'password'"
                      :rules="[rules.required, rules.minMax]"
                      @click:append="showPassword = !showPassword"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="passwordConfirmation"
                      :append-icon="showRePassword ? 'mdi-eye' : 'mdi-eye-off'"
                      :label="this.$t('passwordConfirmation')+`*`"
                      :counter="maxCharacters"
                      :type="showRePassword ? 'text' : 'password'"
                      :rules="[rules.required, rules.minMax, rules.passwordMatch]"
                      @click:append="showRePassword = !showRePassword"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-3" text @click="closeChangePasswordDialog()">{{ $t('close') }}</v-btn>
              <v-btn class="primary" @click="savePassword()">{{ $t('replace') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>

import users from '@/api/users'
import Role from '../Role'
import Feature from '../Feature'
import { showToastSuccess, showToastError } from '../event-bus'

export default {
  name: 'AppLayout',

  data() {
    return {
      drawer: null,
      items: [
        {
          id: 'b7c2b7a0',
          title: this.$t('menu.dashboard'),
          icon: 'mdi-view-dashboard',
          link: '/',
          allowedRoles: [Role.SO, Role.ADMIN, Role.OPERATOR, Role.AUDITOR],
          allowedFeatures: [Feature.TSP, Feature.DSS, Feature.OCSP, Feature.MOBILSIGN]
        },
        {
          id: 'bbff8424',
          title: this.$t('menu.users'),
          icon: 'mdi-account-multiple',
          link: '/users',
          allowedRoles: [Role.SO, Role.ADMIN, Role.AUDITOR],
          allowedFeatures: [Feature.TSP, Feature.DSS, Feature.OCSP, Feature.MOBILSIGN]
        },
        {
          id: 'c881c04e',
          title: this.$t('menu.keystores'),
          icon: 'mdi-key',
          link: '/keystores',
          allowedRoles: [Role.ADMIN, Role.OPERATOR, Role.AUDITOR],
          allowedFeatures: [Feature.TSP, Feature.DSS, Feature.OCSP, Feature.MOBILSIGN]
        },
        {
          id: '65b4852c',
          title: this.$t('menu.tsResponders'),
          icon: 'mdi-timer',
          link: '/tsResponders',
          allowedRoles: [Role.ADMIN, Role.AUDITOR],
          allowedFeatures: [Feature.TSP]
        },
        {
          id: '9ed44010',
          title: this.$t('menu.docSigners'),
          icon: 'mdi-pencil',
          link: '/docSigners',
          allowedRoles: [Role.ADMIN, Role.AUDITOR],
          allowedFeatures: [Feature.DSS, Feature.MOBILSIGN]
        },
        {
          id: 'a836ad53',
          title: this.$t('menu.ocspResponders'),
          icon: 'mdi-key-variant',
          link: '/ocspResponders',
          allowedRoles: [Role.ADMIN, Role.AUDITOR],
          allowedFeatures: [Feature.OCSP]
        },
        {
          id: 'c721a32a',
          title: this.$t('menu.audit'),
          icon: 'mdi-history',
          link: '/audit',
          allowedRoles: [Role.SO, Role.ADMIN, Role.OPERATOR, Role.AUDITOR],
          allowedFeatures: [Feature.TSP, Feature.DSS, Feature.OCSP, Feature.MOBILSIGN]
        },
        {
          id: '25fee14a',
          title: this.$t('menu.tsReport'),
          icon: 'mdi-format-list-bulleted',
          link: '/tsReport',
          allowedRoles: [Role.SO, Role.ADMIN, Role.OPERATOR, Role.AUDITOR],
          allowedFeatures: [Feature.TSP]
        },
        {
          id: '0e19b4a3',
          title: this.$t('menu.system'),
          icon: 'mdi-settings',
          link: '/system',
          allowedRoles: [Role.SO, Role.ADMIN, Role.OPERATOR, Role.AUDITOR],
          allowedFeatures: [Feature.TSP, Feature.DSS, Feature.OCSP, Feature.MOBILSIGN]
        }
      ],
      maxCharacters: 255,
      changePasswordDialogShowed: false,
      oldPassword: null,
      newPassword: null,
      passwordConfirmation: null,
      showPassword: false,
      showRePassword: false,
      valid: false,
      rules: {
        required: v => !!v || this.$t('validation.requiredField'),
        minMax: v => (v && v.length <= this.maxCharacters) || this.$t('validation.mustBeLessThan', { max: this.maxCharacters }),
        passwordMatch: v => (v === this.newPassword) || this.$t('validation.passwordMustBeIdentical')
      }
    }
  },

  computed: {
    isLoggedIn() {
      return !!this.$store.state.currentUser
    },

    username() {
      return this.$store.state.currentUser.username
    },

    getAllowedFeatureList() {
      return this.$store.state.currentUser.features
    },

    hasMatchedItemRolesAndFeatures() {
      return this.items.filter(item => {
        const matchedRole = this.hasMatchedRoles(item.allowedRoles, this.$store.state.currentUser.roles)
        const matchedFeature = this.hasMatchedFeatures(item.allowedFeatures, this.$store.state.currentUser.features)
        return matchedRole && matchedFeature
      })
    }
  },

  methods: {
    logout() {
      this.$store.commit('removeCurrentUser')
      this.$router.push({ name: 'Login' })
    },

    changePassword() {
      this.changePasswordDialogShowed = true
    },

    closeChangePasswordDialog() {
      this.oldPassword = null
      this.newPassword = null
      this.passwordConfirmation = null
      this.changePasswordDialogShowed = false
      this.$refs.form.reset()
    },

    async savePassword() {
      if (!this.$refs.form.validate()) {
        return
      }

      let changePasswordRequestDto = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword
      }
      try {
        await users.changeMyPassword(changePasswordRequestDto)
        showToastSuccess(this.$t('toastMessage.succesfullyUpdated'))
        this.closeChangePasswordDialog()
      } catch (error) {
        showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
      }
    },

    hasMatchedRoles(itemRoles, currentUserRoles) {
      const matchedRoles = currentUserRoles.filter(role => itemRoles.includes(role))
      return !!matchedRoles.length
    },

    hasMatchedFeatures(itemFeatures, currentUserFeatures) {
      const matchedFeatures = currentUserFeatures.filter(feature => itemFeatures.includes(feature))
      return !!matchedFeatures.length
    },

    setAllowedFeaturesToToolbarTitle(features) {
      let toolbarTitle = ''
      features.forEach((value, idx, array) => {
        toolbarTitle += this.$t('feature.' + value)
        if (idx + 1 !== array.length) {
          toolbarTitle += ' - '
        }
      })
      return toolbarTitle
    }
  }
}
</script>

<style>
.hand {
  cursor: pointer;
}
</style>
